import { CaArea, CaGroup } from '../../core';
import { currentState } from '../state';

export function deleteFocus(value: CaArea): void {
    const state = currentState();

    let group: CaGroup;
    for (const g of state.caResult.groups) {
        if (g.areas.includes(value)) {
            group = g;
            break;
        }
    }
    group.areas.splice(group.areas.indexOf(value), 1);
    group.first = group.areas[0];
    group.last = group.areas[group.areas.length - 1];
}
